<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard>
          <OpexFormulario :idTipoOpex="idTipoOpex" :tipoOpex="tipoOpex" :nombreTipoOpex="nombreTipoOpex">
          </OpexFormulario>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'OpexGastoAdmFormNuevo',
  components: {
    OpexFormulario: () => import('../../components/OpexFormulario')
  },
  data: () => ({
    title: 'REGISTRO OPEX GASTO ADMINISTRATIVO',
    page: {
      title: 'Registro OPEX Gasto Administrativo'
    },
    breadcrumbs: [
      {
        text: 'Presupuesto',
        disabled: true
      },
      {
        text: 'OPEX Gasto Administrativo',
        disabled: true
      },
      {
        text: 'Registro',
        disabled: false
      }
    ],
    idTipoOpex: 3,
    tipoOpex: 'gadm',
    nombreTipoOpex: 'Gasto Administrativo'
  }),
  methods: {
    open() {},
    close() {}
  },
  created() {}
};
</script>
